import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from "@mui/material";
import EscoDataGrid from "../../Controls/EscoGrid/EscoDataGrid";
import { getFdoImgList } from "../../../Service/fdoImgService";
import FdoImgView from "./FdoImgView";

//import { Alert, Box, Collapse, FormControl, InputLabel, MenuItem, Select, TextField  } from "@mui/material";
import { deleteFondoImg } from "../../../Service/fdoImgService";

export default function FdoImgDataView() {
    
    const { accessToken } = useContext(AuthContext);
    const [fondosImgs, setFondosImg] = useState([]);
    const [loading, setLoading] = useState(false);

    const { tokenExpiration, getAccessToken } = useContext(AuthContext);
    
    
    const [showDelete, setShowDelete] = useState(false)

    const [rowSelectd, setRowSelectd] = useState("Hola");


    useEffect(() => {
        init();
    }, [])


    const init = () => {
        console.log('expiration', new Date(tokenExpiration), new Date(Date.now()))
        getAccessToken()
        .then((token) => {
            setLoading(true);
            getFdoImgList(token)
                .then((data) => {
                    setFondosImg(data);
                    setLoading(false)
                })
                .catch()
                .finally(() => setLoading(false))

        })
    } 

    

    const columns = [
       // { field: 'CodFondoImg', headerName: 'CodFondoImg', width: 200 },
        { field: 'DescFondo', headerName: 'Fondo', width: 200 },
        { field: 'DescLogo', headerName: 'Logo', width: 200 },
        { field: 'DescLeyenda', headerName: 'Leyenda', width: 200 },
        { field: 'DescPosicionimg', headerName: 'Posición de Imagen', width: 200 }
    ];

    const rows = fondosImgs

    function getRowId(row) {
        return row.CodFondoImg
    }    

    function setData(data) {
        setFondosImg(fondosImgs.concat({ CodFondoImg: data.CodFondoImg, DescLeyenda: data.DescLeyenda, DescImagen: data.DescImagen, DescPosicion: data.DescPosicion, CodLeyendaFirma: data.CodLeyendaFirma}))
    }

    const ConfirmDelete = () => {            
        delFondoImg(rowSelectd);
        setShowDelete(false);
    }

    const delFondoImg = (row) => {


        var frmDelLogosFdoRequest = {
            CodFondoImg: row.CodFondoImg
        }

        const datos = { frmDelLogosFdoRequest }

        deleteFondoImg(datos, accessToken)
            .then(data => {

                if(data!= undefined && data.Message != undefined && data.Message.includes("Error")){
                   
                    init();
                    return;
                }else{
                    init();
                }  
            }).catch(
                error => { 
                    
                }); 

    }

    const closeDeleteDialog = () => {
        setShowDelete(false);
      };   

    return (
        <div style={{ height: 600, width: '100%' }}>
            <Typography variant="button" sx={{ fontSize: 14, color: 'gray' }}>Configuración de Formularios: Fondos - Imagenes </Typography>
            <EscoDataGrid
                rows={rows}
                columns={columns}
                loading={loading}
                getRowId={getRowId}
                pEliminar={true}
                pEditar={false}
                pSetShowDelete={setShowDelete}
                pSetRowSelectd = {setRowSelectd}                
            >
                
                <FdoImgView setData={setData} pInit={init} />

            </EscoDataGrid>

            <Dialog open={showDelete} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    {"Atención"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        ¿Desea eliminar el registro?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDeleteDialog}>Cancelar</Button>
                    <Button onClick={ConfirmDelete} autoFocus>
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
            
        </div>
    );

        

};